module.exports = __webpack_public_path__ + "img/ARIA-text-white.4a0865db.svg";